import React from "react";
import { Routes, Route, Link } from "react-router-dom";
import { Layout, Typography, Space } from "antd";
import {
  Exchanges,
  Homepage,
  News,
  Cryptocurrencies,
  CryptoDetails,
  Navbar,
} from "./components";
import "./App.css";

const App = () => (
  <div className="app">
    <div className="navbar">
      <Navbar />
    </div>
    <div className="main">
      <Layout>
        <div className="routes">
          <Routes>
            <Route path="/" element={<Homepage />} />
            <Route path="/exchanges" element={<Exchanges />} />
            <Route path="/cryptocurrencies" element={<Cryptocurrencies />} />
            <Route path="/crypto/:coinId" element={<CryptoDetails />} />
            <Route path="/news" element={<News />} />
          </Routes>
        </div>
      </Layout>
      <div className="footer">
        <Typography.Title
          level={5}
          style={{ color: "white", textAlign: "center" }}
        >
          𝗖𝗼𝗽𝘆𝗿𝗶𝗴𝗵𝘁 © 2024
          <Link to="/">𝙲𝚛𝚢𝚙𝚝𝚘𝚄𝚗𝚒𝚟𝚎𝚛𝚜𝚎</Link> <br />
          𝘼𝙡𝙡 𝙍𝙞𝙜𝙝𝙩𝙨 𝙍𝙚𝙨𝙚𝙧𝙫𝙚𝙙.
        </Typography.Title>
        <Space>
          <Link to="/">𝐇𝐨𝐦𝐞</Link>
          <Link to="/exchanges">𝐄𝐱𝐜𝐡𝐚𝐧𝐠𝐞𝐬</Link>
          <Link to="/news">𝐍𝐞𝐰𝐬</Link>
        </Space>
      </div>
    </div>
  </div>
);

export default App;
